var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickmenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5313 11C12.5313 11.3029 12.4414 11.5989 12.2732 11.8507C12.1049 12.1025 11.8658 12.2988 11.586 12.4147C11.3062 12.5306 10.9983 12.5609 10.7013 12.5018C10.4042 12.4427 10.1314 12.2969 9.91724 12.0828C9.70309 11.8686 9.55726 11.5958 9.49817 11.2987C9.43909 11.0017 9.46941 10.6938 9.58531 10.414C9.70121 10.1342 9.89747 9.89507 10.1493 9.72681C10.4011 9.55856 10.6971 9.46875 11 9.46875C11.4061 9.46875 11.7956 9.63008 12.0828 9.91724C12.3699 10.2044 12.5313 10.5939 12.5313 11ZM15.5938 9.46875C15.2909 9.46875 14.9948 9.55856 14.743 9.72681C14.4912 9.89507 14.295 10.1342 14.1791 10.414C14.0632 10.6938 14.0328 11.0017 14.0919 11.2987C14.151 11.5958 14.2968 11.8686 14.511 12.0828C14.7251 12.2969 14.998 12.4427 15.295 12.5018C15.5921 12.5609 15.8999 12.5306 16.1797 12.4147C16.4595 12.2988 16.6987 12.1025 16.8669 11.8507C17.0352 11.5989 17.125 11.3029 17.125 11C17.125 10.5939 16.9637 10.2044 16.6765 9.91724C16.3893 9.63008 15.9999 9.46875 15.5938 9.46875ZM6.40625 9.46875C6.1034 9.46875 5.80735 9.55856 5.55553 9.72681C5.30372 9.89507 5.10746 10.1342 4.99156 10.414C4.87566 10.6938 4.84534 11.0017 4.90442 11.2987C4.96351 11.5958 5.10934 11.8686 5.32349 12.0828C5.53764 12.2969 5.81049 12.4427 6.10752 12.5018C6.40455 12.5609 6.71244 12.5306 6.99223 12.4147C7.27203 12.2988 7.51118 12.1025 7.67944 11.8507C7.84769 11.5989 7.9375 11.3029 7.9375 11C7.9375 10.5939 7.77617 10.2044 7.48901 9.91724C7.20184 9.63008 6.81236 9.46875 6.40625 9.46875Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 9.75,
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickmenu);
export default __webpack_public_path__ + "static/media/quickmenu.b9159c659187b9429db1c70603972f83.svg";
export { ForwardRef as ReactComponent };